import {Action, Dispatch} from 'redux';
import {BACKEND_WALLETS} from '../../@crema/services/ApiConfig';
import {showError} from './Common';
import {ApiActionCall, ApiActionTypes} from './Api';
import {
  FETCH_BACKEND_WALLETS,
  FETCH_BACKEND_WALLETS_SUCCESS,
  FETCH_BACKEND_WALLETS_ERROR,
  BackendWalletsActions,
} from '../../types/actions/BackendWallets.actions';
import {IBackendWallet} from '../../types/models/BackendWallet';
import {logger} from '../../shared/logger';

export const fetchBackendWallets = () => async (
  dispatch: Dispatch<ApiActionCall | BackendWalletsActions>,
) => {
  dispatch({type: FETCH_BACKEND_WALLETS});

  const onSuccess = (payload: IBackendWallet[]) => ({
    type: FETCH_BACKEND_WALLETS_SUCCESS,
    payload,
  });
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    logger.error(message);
    dispatch({type: FETCH_BACKEND_WALLETS_ERROR});
    dispatch(showError('Failed to fetch backend wallet list.'));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: BACKEND_WALLETS,
      method: 'GET',
      label: 'Fetch backend wallet list',
      onSuccess,
      onFailure,
    },
  });
};
